import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Gift, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/context/SubscriptionContext';
import { PLANS } from '@/config/subscriptionPlans';
import { auth } from '@/firebase';

export function WelcomeModal({ onOpenPlanModal }) {
  const { isPlanReady, trialPlan } = useSubscription();
  const [open, setOpen] = useState(false);

  // Trial Pro activo
  const isOnTrial = trialPlan === PLANS.PREMIUM_PRO;

  useEffect(() => {
    if (!isPlanReady) return; // Esperar a que el plan esté resuelto

    const uid = auth.currentUser?.uid;
    if (!uid) return; // Esperar a que el usuario esté autenticado

    const storageKey = `rutapp_trial_welcome_seen_${uid}`;
    const alreadySeen = localStorage.getItem(storageKey) === 'true';

    // Mostrar solo si el usuario tiene Trial Pro activo y no lo ha visto
    if (isOnTrial && !alreadySeen) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isPlanReady, isOnTrial]);

  const dismiss = () => {
    const uid = auth.currentUser?.uid;
    if (!uid) return;

    const storageKey = `rutapp_trial_welcome_seen_${uid}`;
    localStorage.setItem(storageKey, 'true');
    setOpen(false);
  };

  const handleStart = () => {
    dismiss();
  };

  const handleViewPlans = () => {
    dismiss();
    onOpenPlanModal();
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-md bg-[#121212] text-white border-[#2A2A2A]">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-1">
            <Gift className="h-5 w-5 text-blue-400 shrink-0" />
            <DialogTitle className="text-xl text-white">Bienvenido a Rutapp Pro</DialogTitle>
          </div>
          <p className="text-sm text-[#A0A0A0] mt-1">
            Tienes 60 días gratis para probar Rutapp con todas las funciones Pro.
          </p>
        </DialogHeader>

        <div className="space-y-2 py-3">
          {[
            'Sin tarjeta',
            'Sin cobro automático',
            'Acceso a perfiles, clientes ilimitados, avisos, estados y funciones avanzadas',
            'Al terminar, seguirás en el plan Free si no activas Premium',
          ].map((point, i) => (
            <div key={i} className="flex items-start gap-2.5">
              <Check className="h-4 w-4 text-blue-400 shrink-0 mt-0.5" />
              <span className="text-sm text-[#C0C0C0]">{point}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-2 pt-2">
          <Button
            className="w-full bg-blue-600 hover:bg-blue-500 text-white font-medium"
            onClick={handleStart}
          >
            Empezar a usar Rutapp Pro
          </Button>
          <Button
            variant="ghost"
            className="w-full text-[#A0B4CC] hover:text-white hover:bg-[#1E2838] text-sm"
            onClick={handleViewPlans}
          >
            Ver planes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
